export default __webpack_public_path__ + "static/banner-two-main-img-4e8c56ac928df0ca2ed579f0fe7f6cf4.png";